module.exports = __webpack_public_path__ + "static/media/ibi.9baec47e.jpg";